import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { SelectModule } from 'src/app/common-components/entity-select/select/select.module';
import { PhoneIssuesChipAndMenuModule } from 'src/app/common-components/phone-issues-chip-and-menu/phone-issues-chip-and-menu.module';
import { PhoneTypeStatusIconsModule } from 'src/app/common-components/phone-type-status-icons/phone-type-status-icons.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { TooltipModule } from 'src/app/common-components/tooltip/tooltip.module';
import { ExtensionToolTipDisplayPipeModule } from 'src/app/pipes/extension-tool-tip-display/extension-tool-tip-display-pipe.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { ExtensionRegisterComponent } from './containers/extension-register.component';
import { LocationExtensionRegisterComponent } from './location-extension-register/location-extension-register.component';
import { ExtensionRegisterEffects } from './state/extension-register.effects';
import { extensionRegisterFeatureKey, extensionRegisterReducer } from './state/extension-register.reducer';
import { ExtensionRegisterViewComponent } from './views/extension-register-view.component';

@NgModule({
   declarations: [ExtensionRegisterComponent, ExtensionRegisterViewComponent, LocationExtensionRegisterComponent],
   exports: [ExtensionRegisterComponent, LocationExtensionRegisterComponent],
   imports: [
      CommonModule,
      FormsModule,
      SelectModule,
      LcsCallStatePipeModule,
      PhoneIssuesChipAndMenuModule,
      PhoneTypeStatusIconsModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatSlideToggleModule,
      MatIconModule,
      MatMenuModule,
      MatCheckboxModule,
      ReactiveFormsModule,
      RouterModule,
      MatMenuModule,
      RegisterModule,
      ScrollingModule,
      EntitySelectModule,
      FormatPhoneNumbersPipeModule,
      TooltipModule,
      ExtensionToolTipDisplayPipeModule,
      EffectsModule.forFeature([ExtensionRegisterEffects]),
      StoreModule.forFeature(extensionRegisterFeatureKey, extensionRegisterReducer),
   ],
})
export class ExtensionRegisterModule {}
